import React, { createContext, useState } from 'react';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import getUserDetailStats from '../../../domain/use_cases/userDetail/getUserDetailStats';

const UserDetailStatsContext = createContext({
    contactsCount: 0,
    notificationsCount: 0,
    fetch: (userUid: string) => {},
    reset: () => {},
    status: ContextStatus.IDLE,
});

export const UserDetailStatsProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [contactsCount, setContactsCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [status, setStatus] = useState(ContextStatus.IDLE);

    const fetch = async (userUid: string) => {
        setStatus(ContextStatus.LOADING);
        try {
            const useCaseResponse = await getUserDetailStats(userUid);
            setContactsCount(useCaseResponse.contactsCount)
            setNotificationsCount(useCaseResponse.notificationsCount)
            setStatus(ContextStatus.SUCCESS);
        } catch (e) {
            setStatus(ContextStatus.ERROR);
        }
    };

    const reset = () => {
        setContactsCount(0);
        setNotificationsCount(0);
        setStatus(ContextStatus.IDLE);
    };

    return (
        <UserDetailStatsContext.Provider
            value={{
                contactsCount,
                notificationsCount,
                fetch,
                reset,
                status,
            }}
        >
            {children}
        </UserDetailStatsContext.Provider>
    );
};

export default UserDetailStatsContext;
